<template>
    <component :is='tela'
        :tela="tela"
        :projeto-id="projetoId"
        :projeto-id-base="projetoIdBase" 
        :nome-id-projeto="nomeIdProjeto" 
        :endpoint="endpoint"
        :endpoint-proposta="endpointProposta"
        :proposta-id-base="propostaIdBase"
        :projeto="projeto"
        :chave-permissao="chavePermissao"
        :ref="tela"
        @update="update"
        @retornarAbas="retornarAbas"
        :projeto-editavel="projetoEditavel"
    />   
</template>
<script>

export default {
    props : {
        tela : {
            type: String,
            required: true
        },
        projetoId : {
            type : String,
            required : true
        },
        projetoIdBase : {
            type : String,
            required : true
        },
        nomeIdProjeto : {
            type : String,
            default : 'projetoId'
        },
        endpoint : {
            type : String,
            default : ''
        },
        endpointProposta : {
            type : String,
            default : ''
        },
        propostaIdBase : {
            type : String,
            default : ''
        },
        projeto : {
            required : true
        },
        chavePermissao: {
            type: String,
            default: null
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    components : {     
        'aneel': () => import('./accordions/aneel'),
        'empresas-cooperadas': () => import('./accordions/empresas'),
        'empresas-executoras': () => import('./accordions/empresas'),
        'rh': () => import('./accordions/recurso_humano'),
        'st': () => import('./accordions/rubricas'),
        'mc': () => import('./accordions/rubricas'),
        'mpe': () => import('./accordions/rubricas'),
        'vd': () => import('./accordions/rubricas'),
        'ou': () => import('./accordions/rubricas'),
        'entregavel': () => import('./accordions/entregaveis'),
        'cronograma_etapa': () => import('./accordions/cronograma_etapa'),
        'cronograma_financeiro': () => import('./accordions/cronograma_financeiro'),
        'investimentos': () => import('./accordions/investimentos'),
        'documentos': () => import('./accordions/contrato_documentacao'),
        'caracteristicas': () => import('./accordions/caracteristicas_projeto'),
        'trl': () => import('./accordions/trl'),
        'cp': () => import('./accordions/capacitacao_profissional'),
        'pc': () => import('./accordions/producao_cientifica'),
        'aie': () => import('./accordions/apoio_infraestrutura'),
        'pi': () => import('./accordions/propriedade_intelectual'),
        'isa': () => import('./accordions/impactos_socioambientais'),
        'ie': () => import('./accordions/impactos_economicos'),
        'investimentos_executora': () => import('./accordions/investimentos_executora'),
    
    },
    methods:{
        update(){
            this.$emit('update');            
        },
        retornarAbas(abas){
            this.$emit('retornarAbas',abas);
        },
        montar(tela){
            /* eslint-disable */
            try{
                this.$refs[tela].montar();
            }catch(e){
            }
        }
    }
}
</script>
<style lang="">
    
</style>